export * from '../action';
export * from '../browser-name';
export * from './ServiceDependencies';
export * from '../slot';
export * from './os-name';
export * from './regularExpression';
export * from './selectionCompatibility';

/**
 * Determine the top window is accessible or not
 */
export function getTopWindowAccessible() {
  try {
    window.top.location.host;
    return true;
  } catch (err) {
    return false;
  }
}
//# sourceMappingURL=index.js.map